import { useAppSelector } from "../../hooks";

export const useIsRAFTEnabled = () => useAppSelector(state => state.header.IsRAFEnabled);

export const useIsUserValidated = () => useAppSelector(state => !state.header.userData?.ShouldShowAccountValidation);

export const useIsUserSubscriber = () => useAppSelector(state => state.header.isUserASubscriber);

export const useSubscriptionLobbyContent = () => useAppSelector(state => state.header.subscriptionLobbyContent);
